
const state = {
  show: false,
  userlistInfo: {}
}

const actions = {
  updateUserlist (ctx, item) {
    ctx.commit('updateUserlist', item)
  }
}

const mutations = {
  updateUserlist (state, item) {
    state.userlistInfo = item
  },
  showAddUserlist (state, item) {
    state.show = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
